var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-5"},[_c('div',{staticClass:"container"},[_c('iframe',{ref:"recras",attrs:{"src":"https://natuurpoortvanloon.recras.nl/onlineboeking","frameborder":"0","width":"100%","height":"522px"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }